// extracted by mini-css-extract-plugin
module.exports = {"Hotlink":"Hotlink_Hotlink__uY1hc","Hotlink_hideOnSmallScreens":"Hotlink_Hotlink_hideOnSmallScreens__x9vq6","MenyIcon":"Hotlink_MenyIcon__2Fouv"};